import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';

const SearchIcon = ({ className, size }) => {
  if (size === 'small') {
    return (
      <svg
        className={getClassName(className)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
          clipRule="evenodd"
        />
      </svg>
    );
  }
  return (
    <svg
      className={getClassName(className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      />
    </svg>
  );
};
SearchIcon.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
};

SearchIcon.defaultProps = {
  size: 'small',
  className: 'w-6 h-6',
};

export default SearchIcon;
